/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IGeraArquivo } from '../../../shared/services/api/fiscal/LCDPR/LCDPRService';
 
async function RelatorioArquivoLCDPR(dados: IGeraArquivo, ano: string){
  
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const lancamentos = dados.lancamentos.map((row) => {
    return [
      {text:  'Q100', alignment: 'center', fontSize: 8, border: [true, true, true, true]},
      {text:  row.datacaixa, alignment: 'center', fontSize: 8, border: [true, true, true, true]},
      {text:  row.idir, alignment: 'center',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.idconta, alignment: 'center',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.numero, alignment: 'left',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.tipodoc, alignment: 'center',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.historico, alignment: 'left',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.participante, alignment: 'left',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.tipolan, alignment: 'center',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.entrada, alignment: 'right',  fontSize: 8, border: [true, true, true, true]},
      {text:  row.saida, alignment: 'right', fontSize: 8, border: [true, true, true, true]},
      {text:  row.saldo, alignment: 'right', fontSize: 8, border: [true, true, true, true]},
      {text:  row.letra, alignment: 'center', fontSize: 8, border: [true, true, true, true]},
    ]; 
  });  
 
  const contas = dados.contas.map((row) => {
    return [
      {text:  '0050', alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
      {text:  row.idconta, alignment: 'center', fontSize: 8, border: [true, true, true, false]},
      {text:  'BR', alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
      {text:  row.banco, alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
      {text:  row.nomebanco, alignment: 'left',  fontSize: 8, border: [true, true, true, false]},
      {text:  row.agencia, alignment: 'left',  fontSize: 8, border: [true, true, true, false]},
      {text:  row.numeroconta, alignment: 'left',  fontSize: 8, border: [true, true, true, false]},
    ]; 
  });  

  const resumo = dados.resumo.map((row) => {
    return [
      {text:  'Q200', alignment: 'center',  fontSize: 8},
      {text:  row.mes+row.ano, alignment: 'center', fontSize: 8},     
      {text:  row.entrada, alignment: 'right',  fontSize: 8},
      {text:  row.saida, alignment: 'right',  fontSize: 8},
      {text:  row.saldo, alignment: 'right',  fontSize: 8},
      {text:  row.letra, alignment: 'center',  fontSize: 8},
    ]; 
  });  


  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }
  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }
  const documentDefinition : any = {
    pageSize: 'A4',
    pageOrientation: 'landscape',  
    pageMargins: [15, 10, 10, 10],
    header: 'simple text',  
    footer: {
      columns: [
        'Left part',
        { text: 'Right part', alignment: 'right' }
      ]
    },
    content: ([
      {   
        table: {
          body: [   
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],  
                table: {
                  widths: [740],
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF',  alignment: 'center', fillColor: process.env.REACT_APP_URL_EMPRESA, border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                  ]
                }
              },
              
            ],
            [
              {text: 'LCDPR', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
              {}
            ]
            
          ]
        }
      },   
      {
        table:{
          widths: [19, 47, 44, 52, 287, 62, 57, 55, 51, 51],
          body: [
            [  
              {text: 'REG', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'NOME_ESC', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'COD_VER', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'CPF', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'NOME', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'IND_SIT_INI_PER', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'SIT_ESPECIAL', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'DT_SIT_ESP', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'DT_INI', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
              {text: 'DT_FIN', alignment: 'center', fillColor: '#dddddd', fontSize: 7},
            ],
            [  
              {text: '0000', alignment: 'center',  fontSize: 8},
              {text: 'LCDPR', alignment: 'center', fontSize: 8},
              {text: '0013', alignment: 'center',  fontSize: 8},
              {text:  dados.produtor.cpf, alignment: 'left',  fontSize: 8},
              {text:  dados.produtor.nome, alignment: 'left',  fontSize: 8},
              {text:  '0', alignment: 'center',  fontSize: 8},
              {text:  '0', alignment: 'center',  fontSize: 8},
              {text:  '', alignment: 'right',  fontSize: 8},
              {text: '0101'+ano, alignment: 'center',  fontSize: 8},
              {text: '3112'+ano, alignment: 'center', fontSize: 8},
            ],
            [  
              {text: '0010', alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
              {text: '1', alignment: 'center',  fontSize: 8,  border: [true, true, true, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, false, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, false, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, false, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, false, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, false, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, false, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, false, false]},
              {text: '', fillColor: '#dddddd', border: [false, false, true, false]},
            ],

          ]
        },    
      },   
      {
        table:{  
          widths: [19, 160, 19, 70, 105, 15, 43, 62, 57, 175],
          body: [
            [  
              {text: 'REG', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'ENDERECO', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
              {text: 'NUM', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'COMPL', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'BAIRRO', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'UF', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'COD_MUN', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'CEP', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'NUM_TEL', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'EMAIL', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
            ],
            [  
              {text: '0030', alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.endereco, alignment: 'left', fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.numero, alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.complemento, alignment: 'left',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.bairro, alignment: 'left',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.uf, alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.idmunicipio, alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.cep, alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.numtel, alignment: 'center',  fontSize: 8, border: [true, true, true, false]},
              {text:  dados.produtor.email, alignment: 'left', fontSize: 8, border: [true, true, true, false]},
            ],
          ]
        },
      },
      dados.fazendas.map(e => {
        const { terceiros } = e;
        const rows = terceiros.map((rowterceiros) => {
          return [
            {text: '0045', border: [true, false, true, false], alignment: 'right',  fontSize: 8},
            {text:  rowterceiros.idir, border: [true, false, true, false],   alignment: 'center',  fontSize: 8},
            {text: rowterceiros.tipocontraparte, border: [true, false, true, false],  alignment: 'center', fontSize: 8},
            {text: rowterceiros.cpf, border: [true, false, true, false],  alignment: 'left', fontSize: 8},
            {text: rowterceiros.nome, border: [true, false, true, false], alignment: 'left',  fontSize: 8},
            {text: rowterceiros.percentual, border: [true, false, true, false], alignment: 'center', fontSize: 8},
          ]; 
        });     
        return [  
          [                
            [     
              {      
                table: { 
                  widths: [19, 30, 20, 30, 53, 48, 41, 58, 114, 20, 33, 57, 15, 32, 36, 28, 28],
                  body: [   
                    [
                      {text: 'REG', alignment: 'center', margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8},
                      {text: 'COD\nIMÓVEL', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
                      {text: 'PAIS', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'MOEDA', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'CAD_ITR', alignment: 'center', fillColor: '#dddddd', margin: [0, 5, 0, 0],  fontSize: 8},
                      {text: 'CAEPF', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'INSCR\nESTADUAL', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
                      {text: 'NOME_IMÓVEL', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'ENDEREÇO', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'NUM', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'COMPL', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'BAIRRO', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'UF', alignment: 'center', margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'COD\nMUN', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
                      {text: 'CEP', alignment: 'center',  margin: [0, 5, 0, 0],  fillColor: '#dddddd', fontSize: 8},
                      {text: 'EXPLORAÇÃO', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
                      {text: 'PARTICIPAÇÃO', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
                    ],
                    [       
                      {text:  '0040', alignment: 'left',  valign: 'middle', fontSize: 8, border: [true, true, true, true]},
                      {text:  e.idir, alignment: 'center', valign: 'bottom', fontSize: 8, border: [true, true, true, true]},
                      {text:  'BR', alignment: 'center', valign: 'top',  fontSize: 8, border: [true, true, true, true]},
                      {text:  'BRL', alignment: 'center',  fontSize: 8, border: [true, true, true, true]},
                      {text:  e.caditr, alignment: 'left',  fontSize: 8, border: [true, true, true, true]},
                      {text:  e.caepf, alignment: 'left',  fontSize: 6, border: [true, true, true, true]},
                      {text:  e.ie, alignment: 'left',  fontSize: 8, border: [true, true, true, true]},
                      {text:  e.descricao, alignment: 'left',  fontSize: 8, border: [true, true, true, true]},
                      {text:  e.endereco, alignment: 'left',  fontSize: 8, border: [true, true, true, true]},
                      {text:  e.numero, alignment: 'center',  fontSize: 8, border: [true, true, true, true]},
                      {text:  e.compl, alignment: 'left', fontSize: 8, border: [true, true, true, true]},
                      {text:  e.bairro, alignment: 'left', fontSize: 8, border: [true, true, true, true]},
                      {text:  e.uf, alignment: 'left', fontSize: 8, border: [true, true, true, true]},
                      {text:  e.idmunicipio, alignment: 'left', fontSize: 8, border: [true, true, true, true]},
                      {text:  e.cep, alignment: 'left', fontSize: 8, border: [true, true, true, true]},
                      {text:  e.tipocontraparte, alignment: 'center', fontSize: 8, border: [true, true, true, true]},
                      {text:  e.percentual, alignment: 'center', fontSize: 8, border: [true, true, true, true]},
                    ],
                  ] 
                }, 
              },                           
              {       
                table:{
                  widths: [19, 30, 59, 53, 165, 114],
                  body: [
                    [
                      {text: 'REG', border: [true, false, true, true], margin: [0, 5, 0, 0],  alignment: 'right', fillColor: '#dddddd', fontSize: 7},
                      {text: 'COD\nIMÓVEL', border: [true, false, true, true],   alignment: 'center', fillColor: '#dddddd', fontSize: 7},
                      {text: 'TIPO\nCONTRAPARTE', border: [true, false, true, true],  alignment: 'center', fillColor: '#dddddd', fontSize: 7},
                      {text: 'ID\nCONTRAPARTE', border: [true, false, true, true],  alignment: 'center', fillColor: '#dddddd', fontSize: 7},
                      {text: 'NOME_CONTRAPARTE', border: [true, false, true, true], margin: [0, 5, 0, 0],  alignment: 'center', fillColor: '#dddddd', fontSize: 7},
                      {text: 'PERC_CONTRAPARTE', border: [true, false, true, true], margin: [0, 5, 0, 0],  alignment: 'center', fillColor: '#dddddd', fontSize: 7},
                    ],
                    ...rows,
                  ]
                },       
              },                          
            ] 
          ]                                      
        ];   
      }),
      {
        table:{
          widths: [19, 30, 23, 27, 183, 35, 114],
          body: [
            [  
              {text: 'REG', alignment: 'center', margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8},
              {text: 'COD\nCONTA', alignment: 'center', fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'PAIS\nCTA', alignment: 'center', fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'BANCO', alignment: 'center', margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'NOME_BANCO', alignment: 'center', margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'AGENCIA', alignment: 'center', margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text:  'NUM_CONTA', alignment: 'center', margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
            ],
            ...contas,          
          ]   
        },
      },  
      {
        table:{
          widths: [19, 45, 44, 27, 55, 20, 221, 63, 22, 49, 49, 49, 30],
          body: [
            [  
              {text: 'REG', alignment: 'center',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8},
              {text: 'DATA', alignment: 'center',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'COD\nIMÓVEL', alignment: 'center', fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'COD\nCONTA', alignment: 'center', fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'NUM_DOC', alignment: 'left',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'TIPO\nDOC', alignment: 'left', fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'HIST', alignment: 'left',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'ID_PARTIC', alignment: 'left',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'TIPO\nLANC', alignment: 'center',  fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'VL_ENTRADA', alignment: 'left',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'VL_SAIDA', alignment: 'left',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'SLD_FIN', alignment: 'left',  margin: [0, 5, 0, 0], fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
              {text: 'NAT_SLD_FIN', alignment: 'left',  fillColor: '#dddddd', fontSize: 8, border: [true, true, true, false]},
            ],
            ...lancamentos,          
          ]
        },
      },  
      {
        table:{
          widths: [19, 45, 80, 84, 71, 50],
          body: [
            [  
              {text: 'REG', alignment: 'center', border: [true, false, true, false], fillColor: '#dddddd', fontSize: 8},
              {text: 'MES', alignment: 'center', fillColor: '#dddddd', fontSize: 8, border: [true, false, true, false]},
              {text: 'VL_ENTRADA', alignment: 'right', fillColor: '#dddddd', fontSize: 8, border: [true, false, true, false]},
              {text: 'VL_SAIDA', alignment: 'right', fillColor: '#dddddd', fontSize: 8, border: [true, false, true, false]},
              {text: 'SLD_FIN', alignment: 'right', fillColor: '#dddddd', fontSize: 8, border: [true, false, true, false]},
              {text: 'NAT_SLD_FIN', alignment: 'left', fillColor: '#dddddd', fontSize: 8, border: [true, false, true, false]},
            ],
            ...resumo,          
          ]
        },
      },  
    ]),            
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();

}
export default RelatorioArquivoLCDPR;

